import {
  FaCheck,
  FaCheckDouble,
  FaExclamationCircle,
  FaMoneyCheckAlt,
  FaShoppingCart,
  FaStore,
  FaTruck,
  FaUserPlus,
} from "react-icons/fa";
import "../../../assets/css/seller/NotificationsInSeller/notificationsInSeller.css";
import SellerMasterLayout from "../../../layout/seller/SellerMasterLayout";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import { Badge, Container } from "react-bootstrap";
import { Card } from "react-bootstrap";
import Swal from "sweetalert2";

function NotificationsInSeller() {
  const { baseUrl, loggedInSeller } = useContext(AppContext);
  const [icon, setIcon] = useState();
  const [title, setTitle] = useState();
  const [description, setDescription] = useState();
  const [status, setStatus] = useState(true);
  const [forUser, setForUser] = useState("all");
  const [notifications, setNotifications] = useState([]);
  const [loadingMarkAll, setLoadingMarkAll] = useState(false);

  //   const formData = new FormData();
  //   formData.append("icon", icon);
  //   formData.append("title", title);
  //   formData.append("description", description);
  //   formData.append("status", status);
  //   formData.append("for", forUser);
  //   console.log(formData);

  //   axios
  //     .post(`${baseUrl}/shop/tpnotification/addNotification`, formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

 const viewAllNotifications = () => {
  if (!loggedInSeller?.id) return;

  const formData = new FormData();
  formData.append("tpshop_id", loggedInSeller.id);

  axios
    .post(
      `${baseUrl}/shop/tpnotification/viewAllNotifications`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      console.log(response.data);

      if (response.data.success) {
        setNotifications(response.data.notifications);
      } else {
        setNotifications([]);
      }
    })
    .catch((error) => {
      console.log(error.response?.data);
      setNotifications([]);
    });
};

 const markAllAsRead = () => {
  setLoadingMarkAll(true);

  const formData = new FormData();
  formData.append("tpshop_id", loggedInSeller.id);

  axios
    .post(
      `${baseUrl}/shop/tpnotification/markAllAsRead`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
setLoadingMarkAll(false);

Swal.fire({
  icon: "success",
  title: "Success",
  text: response.data.message,
});

viewAllNotifications();
    })
    .catch((error) => {
      console.log(error.response?.data);
      setLoadingMarkAll(false);
    });
};

 const markSingleAsRead = (id) => {
  const formData = new FormData();

  formData.append("id", id);
 formData.append("status", "read");

  axios
    .post(
      `${baseUrl}/shop/tpnotification/markSingleAsRead`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.data.success) {
   setNotifications((prev) =>
  prev.map((item) =>
    item.id === id
      ? {
          ...item,
          status: "read",
        }
      : item
  )
);

        Swal.fire({
          icon: "success",
          title: "Notification Status",
          text: response.data.message,
        });

        viewAllNotifications();
      }
    })
    .catch((error) => {
      console.log(error.response?.data);
    });
};

 useEffect(() => {
  if (!loggedInSeller) return;

  viewAllNotifications();

  const interval = setInterval(() => {
    viewAllNotifications();
  }, 5000);

  return () => clearInterval(interval);
}, [loggedInSeller]);

  return (
    <SellerMasterLayout>
      <Container>
        <div className="d-flex justify-content-end mb-3">
          <button className="btn btn-primary" onClick={markAllAsRead}>
            {loadingMarkAll ? "Please wait..." : "Mark All As Read"}
          </button>
        </div>

        {/* Notifications List */}
        
        {notifications?.map((item, index) => (
  <Card key={item.id} className="mb-2">
    <Card.Body>
      <div className="d-flex justify-content-between">
        <div>
          <h6>{item.title}</h6>
          <p>{item.description}</p>

         <small
  style={{
    color: item.status === "read" ? "green" : "red",
  }}
>
  {item.status === "read" ? "Read" : "Unread"}
</small>
        </div>

        <div>
      {item.status === "read" ? (
  <FaCheckDouble color="green" />
) : (
  <FaCheck
    color="red"
    style={{ cursor: "pointer" }}
    onClick={() => markSingleAsRead(item.id)}
  />
)}
          )}
        </div>
      </div>
    </Card.Body>
  </Card>
))}
      </Container>
    </SellerMasterLayout>
  );
}

export default NotificationsInSeller;
